import apiClient from "./apiClient";

export const accessChat = (friendId) =>
  apiClient.post("/api/chat/access", { friendId });

export const getProfile = () => apiClient.get("/api/user/profile");

export const deleteAccount = () => apiClient.delete("/api/user/delete");

export const logout = () => apiClient.post("/api/auth/logout");

export const login = (username, password, turnstileToken = null) =>
  apiClient.post("/api/auth/login", { username, password, turnstileToken });

export const register = (username, password, gender, turnstileToken = null) =>
  apiClient.post("/api/auth/register", {
    username,
    password,
    gender,
    turnstileToken,
  });

// ✅ Optional: fetch messages with pagination (for large chats)
export const getAllChatMessages = (chatId, limit = 50, skip = 0) =>
  apiClient.get(`/api/chat/${chatId}/messages?limit=${limit}&skip=${skip}`);
